export default "__VITE_ASSET__DR6yn8p3__"